import React from 'react';
import './App.css';
import YgoPlayer from './components/YgoPlayer';
import Menu from './components/Menu';
import { GameProvider } from './context/GameContext';

function App() {
  return (
    <GameProvider>
      <div className="responsive-game-container noSelect">
          <YgoPlayer/>
        <div className="menu-container">
          <Menu/>
        </div>
          <YgoPlayer/>
      </div>
    </GameProvider>
  );
}

export default App;
